/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Require variant selection: only remove the class when the customer has actively clicked to select all option groups
document.addEventListener('DOMContentLoaded', function() {
  const productSection = document.querySelector('.Product--requireVariantClick');
  const productForm = document.querySelector('.ProductForm');
  if (!productSection || !productForm) return;

  productForm.addEventListener('submit', function(e) {
    if (productSection.classList.contains('Product--requireVariantClick')) {
      e.preventDefault();
    }
  });

  // Mark all option groups as unselected
  const optionGroups = Array.from(productForm.querySelectorAll('.ProductForm__Option[data-option-group]'));
  if (optionGroups.length === 0) return;
  optionGroups.forEach(function(group) {
    group.setAttribute('data-unselected', '');
  });

  productSection.addEventListener('click', function(e) {
    if (!productSection.classList.contains('Product--requireVariantClick')) return;

    // Find the option group wrapper containing the clicked element
    const clickedGroup = e.target.closest('.ProductForm__Option[data-option-group]');
    if (!clickedGroup) return;

    // Remove data-unselected from the group (show normal selected state)
    clickedGroup.removeAttribute('data-unselected');

    // If no group is unselected, remove the class section
    const remaining = productForm.querySelectorAll('.ProductForm__Option[data-unselected]');
    if (remaining.length === 0) {
      productSection.classList.remove('Product--requireVariantClick');
    }
  }, true);
});

// Sticky Add to Cart functionality
document.addEventListener('DOMContentLoaded', function() {
  const stickyCart = document.querySelector('[data-sticky-cart]');
  const mainAddToCartButton = document.querySelector('.ProductForm__AddToCart');
  const stickyAddToCartButton = document.querySelector('[data-sticky-add-to-cart]');
  const productForm = document.querySelector('.ProductForm');
  
  if (!stickyCart || !mainAddToCartButton || !stickyAddToCartButton || !productForm) return;

  // Function to check if main add to cart button is visible
  function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Function to show/hide sticky cart
  function toggleStickyCart() {
    if (window.innerWidth > 640) {
      // Hide on desktop
      stickyCart.style.display = 'none';
      return;
    }

    const isMainButtonVisible = isElementInViewport(mainAddToCartButton);
    
    if (isMainButtonVisible) {
      stickyCart.style.display = 'none';
    } else {
      stickyCart.style.display = 'block';
    }
  }

  // Handle sticky button click
  stickyAddToCartButton.addEventListener('click', function(e) {
    e.preventDefault();
    const section = productForm.closest('.Product');
    if (section && section.classList.contains('Product--requireVariantClick')) return;
    // Trigger the main form submission
    const mainFormButton = productForm.querySelector('.ProductForm__AddToCart');
    if (mainFormButton && !mainFormButton.disabled) {
      mainFormButton.click();
    }
  });

  // Update sticky cart when variant changes
  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;

    if (variant) {
      // Update price
      const priceElement = stickyCart.querySelector('.StickyAddToCart__Price');
      if (priceElement && variant.price) {
        // priceElement.textContent = Shopify.formatMoney(variant.price, Shopify.money_format);
        priceElement.textContent = variant.price;
      }

      // Update button state
      if (variant.available) {
        stickyAddToCartButton.disabled = false;
        stickyAddToCartButton.textContent = document.querySelector('.ProductForm__AddToCart span').textContent;
      } else {
        stickyAddToCartButton.disabled = true;
        stickyAddToCartButton.textContent = Shopify.locale.sold_out || 'Sold out';
      }
    }
  });

  // Listen for scroll and resize events
  let ticking = false;
  
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(toggleStickyCart);
    }
    ticking = true;
  }

  window.addEventListener('scroll', function() {
    requestTick();
    ticking = false;
  });

  window.addEventListener('resize', function() {
    requestTick();
    ticking = false;
  });

  // Initial check
  toggleStickyCart();
});

document.addEventListener('DOMContentLoaded', () => {
  const readMoreBtn = document.querySelector(".mobile--readmore");

  readMoreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const currentTarget = e.currentTarget;
    console.log(currentTarget);
    const descriptionElement = currentTarget.parentElement.querySelector('.SectionHeader__Description.Rte');

    // Toggle visibility of description
    descriptionElement.classList.toggle("show");
    // Updates the text
    if (currentTarget.innerText === languages.collectionReadMore) {
      currentTarget.innerText = languages.collectionReadLess;
    } else {
      currentTarget.innerText = languages.collectionReadMore;
    }
  });
});

// Quick Buy Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Handle quick buy button clicks with more specific targeting
  document.addEventListener('click', function(e) {
    // Only trigger if the actual button or its direct children are clicked
    const quickBuyButton = e.target.closest('.ProductItem__QuickBuyButton[data-quick-buy]');
    
    // Make sure we're not triggering on color swatches or other elements
    if (!quickBuyButton || e.target.closest('.ColorSwatch__Radio') || e.target.closest('.ProductItem__ColorSwatchList')) {
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();
    
    const variantId = quickBuyButton.getAttribute('data-variant-id');
    const productId = quickBuyButton.getAttribute('data-product-id');
    
    if (!variantId) {
      console.error('No variant ID found for quick buy');
      return;
    }
    
    quickBuyProduct(variantId, quickBuyButton);
  });
});

function quickBuyProduct(variantId, button) {
  // Prevent multiple clicks
  if (button.classList.contains('adding')) {
    return;
  }
  
  // Store original button text
  const originalText = button.innerHTML;
  
  // Show loading state
  button.classList.add('adding');
  button.disabled = true;
  button.innerHTML = '<span class="spinner"></span>';
  
  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Show success state
    button.classList.remove('adding');
    button.classList.add('added');
    button.innerHTML = '✓ Added';
    
    // Dispatch cart refresh event
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    
    // Reset button after 2 seconds
    setTimeout(() => {
      button.classList.remove('added');
      button.disabled = false;
      button.innerHTML = originalText;
    }, 2000);
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
    
    // Show error state
    button.classList.remove('adding');
    button.disabled = false;
    button.innerHTML = 'Error';
    
    // Reset button after 2 seconds
    setTimeout(() => {
      button.innerHTML = originalText;
    }, 2000);
  });
}

// Update product item prices when color swatch is changed
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle color swatch changes directly
  function initColorSwatchPriceUpdates() {
    // Select all color swatch inputs
    const colorSwatchRadios = document.querySelectorAll('.ProductItem__ColorSwatchList .ColorSwatch__Radio');

    colorSwatchRadios.forEach(radio => {
      radio.addEventListener('change', function(e) {
        // Prevent event from bubbling up to quick buy handler
        e.stopPropagation();
        
        const variantUrl = this.getAttribute('data-variant-url');
        if (!variantUrl) return;

        const productItem = this.closest('.ProductItem');
        if (!productItem) return;

        // Extract variant ID from URL
        const variantIdMatch = variantUrl.match(/variant=(\d+)/);
        if (!variantIdMatch) return;

        const variantId = variantIdMatch[1];

        // Update the quick buy button's variant ID when color changes
        const quickBuyButton = productItem.querySelector('.ProductItem__QuickBuyButton[data-quick-buy]');
        if (quickBuyButton) {
          quickBuyButton.setAttribute('data-variant-id', variantId);
        }

         // Fetch the variant data
         fetch(`/variants/${variantId}.js`)
             .then(response => response.json())
             .then(variant => {
               // Update the price
               updateProductItemPrice(productItem, variant);
               // Update the image if variant has one
               updateProductItemImage(productItem, variant, this);
             })
             .catch(error => console.error('Error fetching variant data:', error));
      });
    });
  }

  // Initialize color swatch functionality
  initColorSwatchPriceUpdates();

  // Function to update the product item price
  function updateProductItemPrice(productItem, variant) {
    const priceList = productItem.querySelector('.ProductItem__PriceList');
    if (!priceList) return;

    // Format price according to Danish format (comma as decimal separator, kr after the price)
    function formatPrice(cents) {
      // Convert to number and divide by 100
      const price = cents / 100;

      // Format with comma as decimal separator and no trailing zeros
      let formattedPrice = price.toFixed(2).replace('.', ',').replace(',00', '');

      // Add currency symbol after the price with a space
      return formattedPrice + ' kr';
    }

    // Clear existing price content
    priceList.innerHTML = '';

    // Add the appropriate price elements
    if (variant.compare_at_price > variant.price) {
      // On sale
      const salePrice = document.createElement('span');
      salePrice.className = 'ProductItem__Price Price Price--highlight Text--subdued';
      salePrice.textContent = formatPrice(variant.price);

      const comparePrice = document.createElement('span');
      comparePrice.className = 'ProductItem__Price Price Price--compareAt Text--subdued';
      comparePrice.textContent = formatPrice(variant.compare_at_price);

      priceList.appendChild(salePrice);
      priceList.appendChild(comparePrice);
    } else {
      // Regular price
      const regularPrice = document.createElement('span');
      regularPrice.className = 'ProductItem__Price Price Text--subdued';
      regularPrice.textContent = formatPrice(variant.price);

      priceList.appendChild(regularPrice);
    }

    // Update unit price if it exists
    if (variant.unit_price_measurement) {
      const unitPriceContainer = productItem.querySelector('.ProductItem__UnitPriceMeasurement');
      if (unitPriceContainer) {
        const unitPrice = unitPriceContainer.querySelector('.UnitPriceMeasurement__Price');
        if (unitPrice) {
          unitPrice.textContent = formatPrice(variant.unit_price);
        }

        const referenceValue = unitPriceContainer.querySelector('.UnitPriceMeasurement__ReferenceValue');
        if (referenceValue) {
          referenceValue.textContent = variant.unit_price_measurement.reference_value;
          referenceValue.style.display = variant.unit_price_measurement.reference_value === 1 ? 'none' : '';
        }
      }
    }
  }

  // Function to update the product item image when variant changes
  function updateProductItemImage(productItem, variant, colorSwatchElement) {
    console.log("variant", variant);
    console.log("variant.featured_image", variant.featured_image.src);
    // Only update if variant has a featured image
    if (!variant.featured_image) return;
    const mainImage = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    console.log("mainImage", mainImage);

    // Fallback: use variant data to create image URL
    const imageUrl = variant.featured_image.src;
    mainImage.src = imageUrl;
    mainImage.setAttribute('srcset', imageUrl);
    mainImage.setAttribute('data-srcset', imageUrl);
    mainImage.setAttribute('alt', variant.featured_image.alt || mainImage.getAttribute('alt'));
  }

  // Initialize on page load
  initColorSwatchPriceUpdates();

  // Reinitialize when the page content changes (for AJAX-loaded sections)
  // document.addEventListener('shopify:section:load', initColorSwatchPriceUpdates);
});
